import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addProduct, addProductLevel, updateProduct, updateProductLevel } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function ProductLevelCreate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, productData } = location.state || {};

  const [input, setInput] = useState({
    level: state?.level || "",
    description: state?.description || "",
    amount: state?.amount || "",
    status: state?.status || "ACTIVE",
  });
  const [errors, setErrors] = useState({
    level: "",
    description: "",
    amount: "",
    status: "",
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);



  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.level)) {
      newErrors.level = "Please Enter Level";
      isValid = false;
    } else {
      newErrors.level = "";
    }



    if (input.description === "") {
      newErrors.description = "Please Enter Description";
      isValid = false;
    } else {
      newErrors.description = "";
    }

    if (input.amount === "") {
      newErrors.amount = "Please Enter Amount";
      isValid = false;
    } else {
      newErrors.amount = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          level: input.level,
          description: input.description,
          amount: input.amount,
          productId: productData.id,
          status: input.status,
        };
        updateProductLevel(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/product-level/list", { state: productData });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          level: input.level,
          description: input.description,
          amount: input.amount,
          productId: productData.id,
          status: "ACTIVE",
        };
        addProductLevel(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/product-level/list", { state: productData });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/product-level/list", { state: productData })}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Product Level {state ? "Update" : "Create"} ({productData.name})
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="level" className="form-label">
                        Level
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="level"
                        name="level"
                        value={input.level}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            level: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.level}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Description
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="description"
                        name="Description"
                        value={input.description}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            description: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.description}</div>
                    </div>
                  </div>

                   <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="amount" className="form-label">
                        Amount
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="amount"
                        name="amount"
                        value={input.amount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            amount: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.amount}</div>
                    </div>
                    {state?.id &&<div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>}
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
